<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">Registrar Documento</h2>
  <div class="flex justify-between items-center mb-4">
    <button
      type="button"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="onBack()"
    >
      Volver
    </button>
  </div>
  <form [formGroup]="documentForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <!-- Nombre -->
      <div>
        <label for="nombre" class="block font-semibold mb-1">Nombre</label>
        <input
          id="nombre"
          type="text"
          formControlName="nombre"
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
          [class.border-red-500]="
            documentForm.get('nombre')?.invalid &&
            documentForm.get('nombre')?.touched
          "
          placeholder="Ingrese el nombre"
        />
        <small
          *ngIf="
            documentForm.get('nombre')?.touched &&
            documentForm.get('nombre')?.invalid
          "
          class="text-red-500"
        >
          Nombre es obligatorio y debe tener máximo 100 caracteres.
        </small>

      </div>

      <!-- Descripción -->
      <div>
        <label for="descripcion" class="block font-semibold mb-1"
          >Descripción</label
        >
        <textarea
          id="descripcion"
          formControlName="descripcion"
          class="border border-gray-300 rounded w-full py-2 px-4"
          placeholder="Ingrese una descripción (opcional)"
        ></textarea>
      </div>

      <!-- Tipo de Documento -->
      <div>
        <label for="tipo_documento" class="block font-semibold mb-1"
          >Tipo de Documento</label
        >
        <select
          id="tipo_documento"
          formControlName="tipo_documento"
          class="border border-gray-300 rounded w-full py-2 px-4"
        >
          <option value="" disabled selected>Seleccione un tipo...</option>
          <option value="PDF">PDF</option>
          <option value="WORD">WORD</option>
          <option value="EXCEL">EXCEL</option>
        </select>
        <small
          *ngIf="
            documentForm.get('tipo_documento')?.touched &&
            documentForm.get('tipo_documento')?.invalid
          "
          class="text-red-500"
        >
          Tipo de documento es obligatorio.
        </small>
      </div>

      <!-- Fecha Inicio -->
      <div>
        <label for="fecha_inicio" class="block font-semibold mb-1"
          >Fecha Inicio</label
        >
        <input
          id="fecha_inicio"
          type="date"
          formControlName="fecha_inicio"
          class="border border-gray-300 rounded w-full py-2 px-4"
          [min]="hoy"
        />
      </div>

      <!-- Fecha Fin -->
      <div>
        <label for="fecha_fin" class="block font-semibold mb-1"
          >Fecha Fin</label
        >
        <input
          id="fecha_fin"
          type="date"
          formControlName="fecha_fin"
          class="border border-gray-300 rounded w-full py-2 px-4"
          [min]="hoy"
        />
      </div>

      <!-- Link Formato -->
      <div>
        <label for="link_formato" class="block font-semibold mb-1"
          >Link Formato</label
        >
        <input
          id="link_formato"
          type="url"
          formControlName="link_formato"
          class="border border-gray-300 rounded w-full py-2 px-4"
          placeholder="Ingrese el link del formato (opcional)"
        />
      </div>

      <!-- Oficina -->
      <div>
        <label for="id_oficina" class="block font-semibold mb-1">Oficina</label>
        <select
          id="id_oficina"
          formControlName="id_oficina"
          class="border border-gray-300 rounded w-full py-2 px-4"
        >
          <option [ngValue]="null" disabled selected>
            Seleccione una oficina...
          </option>
          <option *ngFor="let oficina of oficinas" [value]="oficina.id_oficina">
            {{ oficina.nombre }}
          </option>
        </select>
        <small
          *ngIf="
            documentForm.get('id_oficina')?.touched &&
            documentForm.get('id_oficina')?.invalid
          "
          class="text-red-500"
        >
          Oficina es obligatoria.
        </small>
      </div>
    </div>

    <!-- Botones -->
    <div class="flex justify-end items-center mt-6">
      <button
        type="submit"
        [disabled]="documentForm.invalid"
        class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      >
        Registrar
      </button>
    </div>
  </form>
</div>
